import React from 'react';
import { useParams } from 'react-router-dom';
import { AgGroup } from '@indigo-ag/schema';
import { ApolloError } from '@apollo/client';

import i18next from 'core/i18n';
import { NewPage } from 'core/components';
import { LoadingWrapper, text } from 'shared';
import { getCessionGroupById } from 'features/brazil-grower/queries';
import { CessionGroupDetails } from 'features/brazil-grower/components/CessionGroupDetails/CessionGroupDetails';

export const CessionGroupDetailsPage: React.FunctionComponent = () => {
  /**
   * Route Param
   */
  const { id } = useParams<{ id: string }>();

  return (
    <LoadingWrapper
      query={getCessionGroupById}
      queryOptions={{ variables: { agGroupId: parseInt(id, 10) }, fetchPolicy: 'network-only' }}
    >
      {({ data, error }: { data: { getAgGroupById: AgGroup }; error?: ApolloError }) => {
        if (error?.message || !data?.getAgGroupById) {
          return (
            <NewPage backLink="/cessions" backLinkLabel={text.toTitleCase(i18next.t('cessions'))} title="">
              {error?.message.includes('Unable to find') || !data?.getAgGroupById
                ? text.firstLetterUppercase(i18next.t('noCessionFound'))
                : i18next.t('error')}
            </NewPage>
          );
        }

        return (
          <NewPage title={`${i18next.t('cession')} # ${data?.getAgGroupById.id}`} backLink={'/cessions'}>
            <CessionGroupDetails cessionGroup={data?.getAgGroupById} />
          </NewPage>
        );
      }}
    </LoadingWrapper>
  );
};
